<template>
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[20, 50, 100, 150]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
      </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'Pagination',
  computed: {
    ...mapGetters('search', [
      'page',
      'total',
      'pageSize'
    ])
  },
  methods: {
    ...mapActions({
      handleSizeChange: 'search/changePageSize',
      handleCurrentChange: 'search/changePage'
    })
  }
}
</script>

<style lang="scss" scoped>
.pagination-container {
  background-color: #fff;
  padding: 12px;
  box-sizing: border-box;
  display: flex;
  justify-content: flex-end;
}

</style>
